var escapeRegExp = require('./escapeRegExp');

module.exports = function defaultToWhiteSpace(characters) {
  if (characters == null)
    return '\\s';
  else if (characters.source)
    return characters.source;
  else
    return '[' + escapeRegExp(characters) + ']';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/underscore.string/helper/defaultToWhiteSpace.js
 ** module id = 251
 ** module chunks = 0
 **/